/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const HandsFree = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 26 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M23.05 18.83a11.79 11.79 0 0 0 1.72-6.14 12 12 0 1 0-12 11.89c2.026.005 4.02-.5 5.8-1.47l6.64 2.11-2.16-6.39zm-4.41-1l-.74.66a1.54 1.54 0 0 1-.8.36 6.67 6.67 0 0 1-4-1 11.74 11.74 0 0 1-2.89-2.39L9.8 15C7 11.51 7.41 8.68 7.51 8.21A1.44 1.44 0 0 1 8 7.39l.75-.67a.89.89 0 0 1 1.25.07l1.68 1.88a.89.89 0 0 1-.07 1.26l-1.26 1.12a12.17 12.17 0 0 0 1.72 2.68c.368.403.77.774 1.2 1.11.4.31.8.59 1.18.84l.08.05 1.26-1.13a.91.91 0 0 1 1.26.07l1.68 1.88a.89.89 0 0 1-.09 1.26v.02z" fillRule="nonzero" />
      </g>
    </svg>
  </span>
);

HandsFree.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

HandsFree.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default HandsFree;
